import {LegacyRegulationWrapper} from "../legacy-regulation-wrapper";
import {
    IExternalLinksHandlersFactory
} from "../../external-links/handlers-factory/external-links-handlers-factory.interface";
import {
    MichiganExternalLinksHandlersFactory
} from "../../external-links/handlers-factory/regulations/michigan/michigan.external-links-handlers-factory";
import {MichiganRegulationComponents} from "./components/michigan.regulation-components";
import {IRegulationComponents} from "../regulation-components.interface";
import {
    IRegulationMenuItemFactory
} from "../../menu-items-common/regulations-specific/regulation-menu-item-factory.interface";
import {MichiganMenuItemFactory} from "../../menu-item-regulation-specific/michigan/michigan.menu-item-factory";

export class MichiganRegulation extends LegacyRegulationWrapper {
    get isSessionTimerEnabled(): boolean {
        return true;
    }

    get externalLinks(): IExternalLinksHandlersFactory {
        return new MichiganExternalLinksHandlersFactory(this.services);
    }

    get components(): IRegulationComponents {
        return new MichiganRegulationComponents(this.services);
    }

    get menuItems(): IRegulationMenuItemFactory {
        return new MichiganMenuItemFactory(this.services);
    }
}
